import { t } from '@lingui/macro';
import { z } from 'zod';

export const SendPasswordResetSchema = () =>
  z.object({
    email: z
      .string({
        required_error: t`L'email est obligatoire.`,
        invalid_type_error: t`L'email doit être valide.`,
      })
      .trim()
      .email(t`email invalide.`)
      .min(6, t`L'email est obligatoire.`),
  });

export type SendPasswordResetSchemaT = z.infer<
  ReturnType<typeof SendPasswordResetSchema>
>;
